import { ItemMetaEntity } from '@generated/gql';
import { ethers } from 'ethers';

export const OTHER_ITEMS = {
  guildReinforcement: 'SACRA_OTHER_1_ITEM',
  reduceFragility: 'SACRA_OTHER_2_ITEM',
  exitFromDungeon: 'SACRA_OTHER_3_ITEM',
  restInShelter: 'SACRA_OTHER_5_ITEM',
};

export function prepareDataForOtherItems(item: ItemMetaEntity, heroAdr: string, heroId: number): string | null {
  if (item.name === OTHER_ITEMS.exitFromDungeon) {
    return getDataExitFromDungeon(heroAdr, heroId);
  } else if (item.name === OTHER_ITEMS.restInShelter) {
    return getDataRestInShelter(heroAdr, heroId);
  }
  return null;
}

export function getDataForGuildReinforcement(
  heroAdr: string,
  heroId: number,
  helperAdr: string,
  helperId: number,
): string {
  return ethers.AbiCoder.defaultAbiCoder().encode(
    ['address', 'uint', 'address', 'uint'],
    [heroAdr, heroId, helperAdr, helperId],
  );
}

export function getDataReduceFragility(itemAdr: string, itemId: number): string {
  return ethers.AbiCoder.defaultAbiCoder().encode(['address', 'uint'], [itemAdr, itemId]);
}

export function getDataExitFromDungeon(heroAdr: string, heroId: number): string {
  return ethers.AbiCoder.defaultAbiCoder().encode(['address', 'uint'], [heroAdr, heroId]);
}

export function getDataRestInShelter(heroAdr: string, heroId: number): string {
  return ethers.AbiCoder.defaultAbiCoder().encode(['address', 'uint'], [heroAdr, heroId]);
}
